$(function(){
  $('.freePage-wrap__accordion_ttl').click(function(){
    var index = $('.freePage-wrap__accordion_ttl').index(this);
    $('.freePage-wrap__accordion_ttl').each(function(i){
      if(index == i){
        if($(this).hasClass('active')){
          $(this).removeClass('active');
          $(this).next('.freePage-wrap__accordion_in').slideUp('fast');
        } else {
          $(this).addClass('active');
          $(this).next('.freePage-wrap__accordion_in').slideDown('fast');
        }
      }
    });
  });
});